export const childrenRoute = [
	// 公司介绍
	{
		path: '/companyIntroduction',
		name: 'companyIntroduction',
		component: () => import('../views/aboutUs/list/companyIntroduction.vue')
	},
	// 成功案例
	{
		path: '/successCase',
		name: 'successCase',
		component: () => import('../views/aboutUs/list/successCase.vue')
	},
	// 社会责任
	{
		path: '/socialResponsibility',
		name: 'socialResponsibility',
		component: () => import('../views/aboutUs/list/socialResponsibility.vue')
	},
	// 人才招聘
	{
		path: '/recruit',
		name: 'recruit',
		component: () => import('../views/aboutUs/list/recruit.vue')
	},
	// 发展历程
	{
		path: '/developmentHistory',
		name: 'developmentHistory',
		component: () => import('../views/aboutUs/list/developmentHistory.vue')
	},
]